import Store from "@/store/index.js";
import axios from "axios";
import MetodosGenerales from "@/utils/metodosgenerales.vue.js";
const domain = Store.state.domain;
export default {
  Desencriptar(vm, url) {
    var datos = new FormData();
    datos.append("url", url);
    return vm.axios
      .post(
        `${vm.domain.domainNameForApi}ReporteGeneral/DesencriptarUrl`,
        datos
      )
      .then((response) => response.data);
  },
  Notificacion(vm, data) {
    data.append("uslogin", MetodosGenerales.ObtenerUserName());
    return vm.axios
      .post(`${vm.domain.domainNameForApi}ReporteGeneral/Notificacion`, data)
      .then((response) => response.data);
  },
  EliminarNotificacion(vm) {
    return vm.axios
      .post(`${vm.domain.domainNameForApi}ReporteGeneral/EliminarNotificacion`)
      .then((response) => response.data);
  },
  Eliminar(vm, data) {
    return vm.axios
      .post(`${vm.domain.domainNameForApi}ReporteGeneral/Eliminar`, data)
      .then((response) => response.data);
  },
  ValidarReporte(vm, data) {
    return vm.axios
      .post(`${vm.domain.domainNameForApi}ReporteGeneral/ValidarReporte`, data)
      .then((response) => response.data);
  },
  ValidarEdiccion(vm, data) {
    return vm.axios
      .post(`${vm.domain.domainNameForApi}ReporteGeneral/ValidarEdiccion`, data)
      .then((response) => response.data);
  },
  GarantiasFianzas(vm, data) {
    return vm.axios
      .post(
        `${vm.domain.domainNameForApi}ReporteGeneral/GarantiasFianzas`,
        data
      )
      .then((response) => response.data);
  },
  GarantiasCaucion(vm, data) {
    return vm.axios
      .post(
        `${vm.domain.domainNameForApi}ReporteGeneral/GarantiasCaucion`,
        data
      )
      .then((response) => response.data);
  },
  GarantiasOtros(vm, data) {
    return vm.axios
      .post(`${vm.domain.domainNameForApi}ReporteGeneral/GarantiasOtros`, data)
      .then((response) => response.data);
  },
  Verpago(vm, data) {
    return vm.axios
      .post(`${vm.domain.domainNameForApi}ReporteGeneral/Verpago`, data)
      .then((response) => response.data);
  },
  Autorizado(vm, data) {
    return vm.axios
      .post(`${vm.domain.domainNameForApi}ReporteGeneral/Autorizado`, data)
      .then((response) => response.data);
  },
  GuardarAsegurado(vm, data) {
    return vm.axios
      .post(
        `${vm.domain.domainNameForApi}ReporteGeneral/GuardarAsegurado`,
        data
      )
      .then((response) => response.data);
  },
  Precierre(vm, data) {
    return vm.axios
      .post(`${vm.domain.domainNameForApi}ReporteGeneral/Precierre`, data)
      .then((response) => response.data);
  },
  PosibleConclusion(vm, data) {
    return vm.axios
      .post(
        `${vm.domain.domainNameForApi}ReporteGeneral/PosibleConclusion`,
        data
      )
      .then((response) => response.data);
  },
  async MovimientosContraloria(vm, datos) {
    var datosReporte = new FormData();
    datosReporte.append("aiclave", datos.aiclave);
    return vm.axios
      .post(
        `${vm.domain.domainNameForApi}ReporteGeneral/MovimientosContraloria`,
        datosReporte
      )
      .then((response) => response.data);
  },
  GuardarPosibleConclusion(vm, data) {
    return vm.axios
      .post(
        `${vm.domain.domainNameForApi}ReporteGeneral/GuardarPosibleConclusion`,
        data
      )
      .then((response) => response.data);
  },
  DatosVehiculo(vm, data) {
    return vm.axios
      .post(`${vm.domain.domainNameForApi}ReporteGeneral/DatosVehiculo`, data)
      .then((response) => response.data);
  },
  GuardarDelitos(vm, data) {
    return vm.axios
      .post(`${vm.domain.domainNameForApi}ReporteGeneral/GuardarDelitos`, data)
      .then((response) => response.data);
  },
  GuardarNumSiniestro(vm, data) {
    return vm.axios
      .post(
        `${vm.domain.domainNameForApi}ReporteGeneral/GuardarNumSiniestro`,
        data
      )
      .then((response) => response.data);
  },
  GuardarAjustador(vm, data) {
    return vm.axios
      .post(
        `${vm.domain.domainNameForApi}ReporteGeneral/GuardarAjustador`,
        data
      )
      .then((response) => response.data);
  },
  async AgregarMovimientosContraloria(vm, mov, fechaAbo, sn, obs, esid, datos) {
    var datosReporte = new FormData();
    datosReporte.append("Ceclave", mov);
    datosReporte.append("nrreporte", datos.nrreporte);
    datosReporte.append("svindice", datos.svindice);
    datosReporte.append("aiclave", datos.aiclave);
    datosReporte.append("fechaAbo", fechaAbo);
    datosReporte.append("sn", sn);
    datosReporte.append("obs", obs);
    datosReporte.append("esid", esid);
    return vm.axios
      .post(
        `${vm.domain.domainNameForApi}ReporteGeneral/AgregarMovimientosContraloria`,
        datosReporte
      )
      .then((response) => response.data);
  },
  ActualizarContacto(vm, data) {
    return vm.axios
      .post(
        `${vm.domain.domainNameForApi}ReporteGeneral/ActualizarContacto`,
        data
      )
      .then((response) => response.data);
  },
  ActualizarTerminoAJ(vm, data) {
    return vm.axios
      .post(
        `${vm.domain.domainNameForApi}ReporteGeneral/ActualizarTerminoAJ`,
        data
      )
      .then((response) => response.data);
  },
  ActualizarTermino(vm, data) {
    return vm.axios
      .post(
        `${vm.domain.domainNameForApi}ReporteGeneral/ActualizarTermino`,
        data
      )
      .then((response) => response.data);
  },
  MenuReporte(vm, data) {
    return vm.axios
      .post(`${vm.domain.domainNameForApi}ReporteGeneral/MenuReporte`, data)
      .then((response) => response.data);
  },
  MotivosNoLib(vm, data) {
    return vm.axios
      .post(`${domain.domainNameForApi}ReporteGeneral/MotivosNoLib`, data)
      .then((response) => response.data);
  },
  MotivosLibVehNoLib(vm, data) {
    return vm.axios
      .post(`${domain.domainNameForApi}ReporteGeneral/MotivosLibVehNoLib`, data)
      .then((response) => response.data);
  },
  async ObtenerCorralon(datos) {
    var datosReporte = new FormData();
    datosReporte.append("nrreporte", datos.nrreporte);
    datosReporte.append("svindice", datos.svindice);
    let response = await axios.post(
      `${domain.domainNameForApi}ReporteGeneral/ObtenerCorralon`,
      datosReporte
    );
    return response.data;
  },
  //Desconclusion
  async ValidarEFirma(vm, efirma) {
    var formData = new FormData();
    formData.append("efirma", efirma);

    let response = await vm.axios.post(
      `${domain.domainNameForApi}ReporteGeneral/ValidarEFirma`,
      formData
    );

    return response.data;
  },

  async obtenerValidacionesReporte(vm) {
    let datosReporte = await MetodosGenerales.obtenerSessionReporte("reporte");
    var formData = new FormData();
    formData.append("nrreporte", datosReporte.nrreporte);
    formData.append("svindice", datosReporte.svindice);
    formData.append("uslogin", MetodosGenerales.ObtenerUserName());

    let response = await axios.post(
      `${domain.domainNameForApi}ReporteGeneral/ObtenerValidacionesReporte`,
      formData
    );

    return response.data;
  },

  // async ObsSolicitudDesc(vm) {
  //   let datosReporte = await MetodosGenerales.obtenerSessionReporte("reporte");
  //   var formData = new FormData();
  //   formData.append("nrreporte", datosReporte.nrreporte);
  //   formData.append("svindice", datosReporte.svindice);

  //   let response = await vm.axios.post(
  //     `${domain.domainNameForApi}ReporteGeneral/ObservacionesDesconclusion`,
  //     formData
  //   );

  //   return response.data;
  // }, // ESTE METODO NO ESTA SIENDO OCUPADO POR EL MOMENTO -- SI TU LO GENERASTE Y ESTAS SEGURO QUE YA NO SE USURA BORRALO.

  // async fechasReporte(vm) {
  //   let datosReporte = await MetodosGenerales.obtenerSessionReporte("reporte");
  //   var formData = new FormData();
  //   formData.append("nrreporte", datosReporte.nrreporte);
  //   formData.append("svindice", datosReporte.svindice);

  //   let response = await vm.axios.post(
  //     `${domain.domainNameForApi}ReporteGeneral/FechasReporteDesconclusion`,
  //     formData
  //   );

  //   return response.data;
  // }, // ESTE METODO NO ESTA SIENDO OCUPADO POR EL MOMENTO -- SI TU LO GENERASTE Y ESTAS SEGURO QUE YA NO SE USURA BORRALO.

  async fechaSvreporte(vm, datos) {
    var formData = new FormData();
    formData.append("nrreporte", datos.nrreporte);
    formData.append("svindice", datos.svindice);

    let response = await vm.axios.post(
      `${domain.domainNameForApi}ReporteGeneral/Fechasvreporte`,
      formData
    );
    return response.data;
  },
  ValidarVehDetenido(vm, data) {
    return vm.axios
      .post(
        `${vm.domain.domainNameForApi}ReporteGeneral/ValidarVehDetenido`,
        data
      )
      .then((response) => response.data);
  },
  ValidarTipoServicio(vm, data) {
    return vm.axios
      .post(
        `${vm.domain.domainNameForApi}ReporteGeneral/ValidarTipoServicio`,
        data
      )
      .then((response) => response.data);
  },
  async ObtenerTerceros(vm, datosReporte) {
    var formData = new FormData();
    formData.append("nrreporte", datosReporte.nrreporte);
    formData.append("svindice", datosReporte.svindice);
    let response = await vm.axios.post(
      `${domain.domainNameForApi}ReporteGeneral/ObtenerTerceros`,
      formData
    );
    return response.data;
  },

  async obtenerDatosReporte(vm) {
    var formData = new FormData();
    formData.append("nrreporte", vm.displayInputs.nrreporte);
    formData.append("svindice", vm.displayInputs.svindice);
    return axios
      .post(
        `${domain.domainNameForApi}ReporteGeneral/ObtenerDatosReporte`,
        formData
      )
      .then((response) => response.data);
  },
  async reasignarAbogado(vm, newprclave, newprnombre) {
    var formData = new FormData();
    formData.append("nrreporte", vm.displayInputs.nrreporte);
    formData.append("svindice", vm.displayInputs.svindice);
    formData.append("aiclave", vm.displayInputs.aiclave);

    formData.append("newprclave", newprclave);
    formData.append("oldprclave", vm.datosBusqueda.prclave);
    formData.append("oldprnombre", vm.prnombre);
    formData.append("newprnombre", newprnombre);

    return axios
      .post(
        `${domain.domainNameForApi}ReporteGeneral/ReasignarAbogados`,
        formData
      )
      .then((response) => response.data);
  },

  //ObtenerEstadisticaGeneral(vm, data) {
  //    return axios
  //        .post(
  //            `${domain.domainNameForApi}ReporteGeneral/ObtenerEstadisticaGeneralExcel`,
  //            data
  //        )
  //        .then((response) => response.data);
  //},

  ObtenerShowMovMotivoNoLib(ceclave, data, respuesta) {
    var formData = new FormData();
    formData.append("ceclave", ceclave);
    formData.append("nrreporte", data.nrreporte);
    formData.append("svindice", data.svindice);
    formData.append("aiclave", data.aiclave);
    formData.append("respuesta", respuesta);

    return axios
      .post(
        `${domain.domainNameForApi}ReporteGeneral/ObtenerShowMovMotivoNoLib`,
        formData
      )
      .then((response) => response.data);
  },
  ObtenerDoctosPagosLibVeh(data) {
    var formData = new FormData();
    formData.append("nrreporte", data.nrreporte);
    formData.append("svindice", data.svindice);

    return axios
      .post(
        `${domain.domainNameForApi}ReporteGeneral/ObtenerDoctosPagosLibVeh`,
        formData
      )
      .then((response) => response.data);
  },
  //Perfil(vm) {
  //    return vm.axios.post(`${vm.domain.domainNameForApi}Dashboard/DashboardPerfil`).then(response => response.data);
  //},
  ValidacionRegex(vm, data) {
    return vm.axios
      .post(`${domain.domainNameForApi}ReporteGeneral/ValidacionRegex`, data)
      .then((response) => response.data);
  },

  ObtenerCliente(vm, data) {
    return vm.axios
      .post(`${domain.domainNameForApi}ReporteGeneral/ObtenerCliente`, data)
      .then((response) => response.data);
  },

  VerificarReporte(data) {
    var formData = new FormData();
    formData.append("nrreporte", data.nrreporte);
    formData.append("svindice", data.svindice);

    return axios
      .post(
        `${domain.domainNameForApi}ReporteGeneral/VerificarReporte`,
        formData
      )
      .then((response) => response.data);
  },
  async ObtenerEstados(vm) {
    let response = await vm.axios.post(
      `${domain.domainNameForApi}ReporteGeneral/ObtenerEstados`
    );
    vm.opciones.Catalogo = response.data;
  },
  async ObtenerLocalidades(vm, esclave) {
    var formData = new FormData();
    formData.append("esclave", esclave);
    let response = await vm.axios.post(
      `${domain.domainNameForApi}ReporteGeneral/ObtenerLocalidades`,
      formData
    );
    vm.opcionesLocalidad.Catalogo = response.data;
  },
  async ObtenerAfianzadoras() {
    return axios
      .post(`${domain.domainNameForApi}Fianzas/ObtenerAfianzadoras`)
      .then((response) => response.data);
  },
  ObtenerTipoCertificado(data) {
    return axios
      .post(
        `${domain.domainNameForApi}ReporteGeneral/ObtenerTipoCertificado`,
        data
      )
      .then((response) => response.data);
  },
  TotalNotas(data) {
    return axios
      .post(`${domain.domainNameForApi}ReporteGeneral/TotalNotas`, data)
      .then((response) => response.data);
  },
  ObtenerNotas(data) {
    return axios
      .post(`${domain.domainNameForApi}ReporteGeneral/ObtenerNotas`, data)
      .then((response) => response.data);
  },
  NuevaNota(data) {
    return axios
      .post(`${domain.domainNameForApi}ReporteGeneral/NuevaNota`, data)
      .then((response) => response.data);
  },
  EditarNota(data) {
    return axios
      .post(`${domain.domainNameForApi}ReporteGeneral/EditarNota`, data)
      .then((response) => response.data);
  },
  EliminarNota(data) {
    return axios
      .post(`${domain.domainNameForApi}ReporteGeneral/EliminarNota`, data)
      .then((response) => response.data);
  },
  async ObtenerPruebasAsistenciaCivil(data) {
    var formData = new FormData();
    formData.append("nrreporte", data.nrreporte);
    formData.append("svindice", data.svindice);
    let response = await axios.post(
      `${domain.domainNameForApi}ReporteGeneral/ObtenerPruebasAsistenciaCivil`,
      formData
    );
    return response.data;
  },
  async ObtenerPrestacionesCivil(data) {
    var formData = new FormData();
    formData.append("nrreporte", data.nrreporte);
    formData.append("svindice", data.svindice);
    let response = await axios.post(
      `${domain.domainNameForApi}ReporteGeneral/ObtenerPrestacionesCivil`,
      formData
    );
    return response.data;
  },
  async ValidarMultiResp(data) {
    var formData = new FormData();
    formData.append("nrreporte", data.nrreporte);
    formData.append("svindice", data.svindice);
    let response = await axios.post(
      `${domain.domainNameForApi}ReporteGeneral/ValidarMultiResp`,
      formData
    );
    return response.data[0];
  },
  async ObtienerEnlacesReportes(data) {
    let response = await axios.post(
      `${domain.domainNameForApi}ReporteGeneral/ObtienerEnlacesReportes`,
      data
    );
    return response.data;
  },
  async validaEnlaceReporte(data) {
    let response = await axios.post(
      `${domain.domainNameForApi}ReporteGeneral/validaEnlaceReporte`,
      data
    );
    return response.data;
  },
  GuardarEnlaceReporte(data) {
    return axios
      .post(
        `${domain.domainNameForApi}ReporteGeneral/GuardarEnlaceReporte`,
        data
      )
      .then((response) => response.data);
  },

  async ValidarConstanciaLiberacionVeh(data) {
    var formData = new FormData();
    formData.append("nrreporte", data.nrreporte);
    formData.append("svindice", data.svindice);
    let response = await axios.post(
      `${domain.domainNameForApi}ReporteGeneral/ValidarConstanciaLiberacionVeh`,
      formData
    );

    return response.data[0];
  },

  async ObtenerCamposEdicionAgente() {
    let datos = await MetodosGenerales.obtenerSessionReporte("reporte"); //se tiene que pasar como variable
    var formData = new FormData();
    formData.append("nrreporte", datos.nrreporte);
    formData.append("svindice", datos.svindice);
    formData.append("aiclave", datos.aiclave);
    formData.append("uslogin", MetodosGenerales.ObtenerUserName());

    let response = await axios.post(
      `${domain.domainNameForApi}ReporteGeneral/ObtenerCamposEdicionAgente`,
      formData
    );
    return response.data[0];
  },

  async ObtenerListadoAgentes(clclave, busqueda) {
    var formData = new FormData();
    formData.append("clclave", clclave);
    formData.append("busqueda", busqueda);
    let response = await axios.post(
      `${domain.domainNameForApi}ReporteGeneral/ObtenerListadoAgentes`,
      formData
    );
    return response.data;
  },

  async ActualizaAgenteReporte(ageId) {
    let datos = await MetodosGenerales.obtenerSessionReporte("reporte"); //se tiene que pasar como variable
    var formData = new FormData();
    formData.append("nrreporte", datos.nrreporte);
    formData.append("svindice", datos.svindice);
    formData.append("ageId", ageId);
    formData.append("uslogin", MetodosGenerales.ObtenerUserName());

    let response = await axios.post(
      `${domain.domainNameForApi}ReporteGeneral/ActualizaAgenteReporte`,
      formData
    );
    return response.data[0];
  },

  /*Favoritos */
  async ObtenerIcono() {
    let response = await axios.post(`${domain.domainNameForApi}ReporteGeneral/ObtenerIcono`);
    return response.data;
  },
  async ObtenerCategorias(data) {
    let response = await axios.post(`${domain.domainNameForApi}ReporteGeneral/ObtenerCategorias`, data);
    return response.data
  },
  async Favoritos_ObtenerReportes(data) {
    let response = await axios.post(`${domain.domainNameForApi}ReporteGeneral/Favoritos_ObtenerReportes`, data)
    return response.data;
  },
  async ValidacionCategorias(data) {
    let response = await axios.post(`${domain.domainNameForApi}ReporteGeneral/ValidacionCategorias`, data)
    return response.data;
  },
  async NuevaCategoria(data) {
    let response = await axios.post(`${domain.domainNameForApi}ReporteGeneral/NuevaCategoria`, data);
    return response.data;
  },
  async EditarCategoria(data) {
    let response = await axios.post(`${domain.domainNameForApi}ReporteGeneral/EditarCategoria`, data);
    return response.data;
  },
  async ContadorFavorito(data) {
    let response = await axios.post(`${domain.domainNameForApi}ReporteGeneral/ContadorFavorito`, data)
    return response.data
  },
  async ValidarReporteFavorito(data) {
    let response = await axios.post(`${domain.domainNameForApi}ReporteGeneral/ValidarReporteFavorito`, data);
    return response.data;
  },
  async GuardarFavorito(data) {
    let response = await axios.post(`${domain.domainNameForApi}ReporteGeneral/GuardarFavorito`, data);
    return response.data;
  },
  async ObtenerFavorito(data) {
    let response = await axios.post(`${domain.domainNameForApi}ReporteGeneral/ObtenerFavorito`, data)
    return response.data;
  },
  async EliminarFavorito(data) {
    let response = await axios.post(`${domain.domainNameForApi}ReporteGeneral/EliminarFavorito`, data)
    return response.data;
  },
  async EliminarCategoria(data) {
    let response = await axios.post(`${domain.domainNameForApi}ReporteGeneral/EliminarCategoria`, data)
    return response.data;
  },
  async GuardarFavorito(data) {
    let response = await axios.post(`${domain.domainNameForApi}ReporteGeneral/GuardarFavorito`, data);
    return response.data;
  },
  async ContadorFavorito(data) {
    let response = await axios.post(`${domain.domainNameForApi}ReporteGeneral/ContadorFavorito`, data)
    return response.data
  },
  async ObtenerTipoActor(actor) {
    var datosReporte = new FormData();
    datosReporte.append("actor", actor);
    let response = await axios.post(`${domain.domainNameForApi}ReporteGeneral/ObtenerTipoActor`, data)
    return response.data
  },
  async ValidarIVR(nrreporte, svindice, IVR) {
    var datosReporte = new FormData();
    datosReporte.append("nrreporte", nrreporte);
    datosReporte.append("svinidice", svindice);
    datosReporte.append("IVR", IVR);
    let response = await axios.post(`${domain.domainNameForApi}ReporteGeneral/ValidarIVR`, data)
    return response.data
  },
  async ObtenerDatosReporteAcompanamiento(vm) {
    var formData = new FormData();
    formData.append("nrreporte", vm.displayInputs.nrreporte);
    formData.append("svindice", vm.displayInputs.svindice);
    return axios
      .post(
        `${domain.domainNameForApi}ReporteGeneral/ObtenerDatosReporteAcompanamiento`,
        formData
      )
      .then((response) => response.data);
  },

  async CostoAcompanamiento(data) {
    var datosReporte = new FormData();
    datosReporte.append("nrreporte", data.nrreporte);
    datosReporte.append("svindice", data.svindice);
    let response = await axios.post(`${domain.domainNameForApi}ReporteGeneral/CostoAcompanamiento`, datosReporte)
    return response.data
  },
  async AgregarAcompanamiento(data) {
    var datosReporte = new FormData();
    datosReporte.append("nrreporte", data.nrreporte);
    datosReporte.append("svindice", data.svindice);
    datosReporte.append("prclave", data.prclave);
    datosReporte.append("csfhacomp", data.acfacomp);
    datosReporte.append("cscosto", data.accosto);
    datosReporte.append("csobs", data.acobservaciones);
    datosReporte.append("cscertificado", data.accertifciado);
    datosReporte.append("plid", data.plid);
    datosReporte.append("ctcid", data.ctcid);
    datosReporte.append("uslogin", MetodosGenerales.ObtenerUserName());
    let response = await axios.post(`${domain.domainNameForApi}ReporteGeneral/AgregarAcompanamiento`, datosReporte)
    return response.data
  },
  async validaAcompanamiento(data) {
    var datosReporte = new FormData();
    datosReporte.append("nrreporte", data.nrreporte);
    datosReporte.append("svindice", data.svindice);
    datosReporte.append("csfhacomp", data.acfacomp);
    let response = await axios.post(`${domain.domainNameForApi}ReporteGeneral/validaAcompanamiento`, datosReporte)
    return response.data
  },

  obtenerMotivosAcomp(vm) {
    var formData = new FormData();
    axios
      .post(`${domain.domainNameForApi}ReporteGeneral/obtenerMotivosAcomp`, formData)
      .then((response) => {
        vm.opcionesMotivo = response.data;
      });
  },
  ObtenerProveedorAcom(vm) {
    return vm.axios.post(`${vm.domain.domainNameForApi}ReporteGeneral/ObtenerProveedorAcom`).then(response => response.data);
  },
  async MotivosImpulsos(vm) {
    var datosReporte = new FormData();
    return vm.axios
      .post(
        `${vm.domain.domainNameForApi}ReporteGeneral/MotivosImpulsos`,
        datosReporte
      )
      .then((response) => response.data);
  },
  async AgregarMovimientosImpulsosProcesales(vm) {
    var datosReporte = new FormData();

    datosReporte.append("nrreporte", vm.datosReporte.nrreporte);
    datosReporte.append("svindice", vm.datosReporte.svindice);
    datosReporte.append("impmonto", vm.monto);
    datosReporte.append("impautoriza", vm.autoriza);
    datosReporte.append("impnombre", vm.nombre);
    datosReporte.append("imptipoautoriza", vm.tipo);
    datosReporte.append("miid", vm.motivo);
    datosReporte.append("impuso", vm.uso);
    datosReporte.append("impobs", vm.observaciones);
    datosReporte.append("impfhabo", vm.selectedDate);
    datosReporte.append("uslogin", MetodosGenerales.ObtenerUserName());


    return vm.axios
      .post(
        `${vm.domain.domainNameForApi}ReporteGeneral/AgregarMovimientosImpulsosProcesales`,
        datosReporte
      )
      .then((response) => response.data);
  },
  async conclusionImpulsos(vm, datos) {
    var formData = new FormData();
    formData.append("nrreporte", datos.nrreporte);
    formData.append("svindice", datos.svindice);
    formData.append("aiclave", datos.aiclave);

    let response = await vm.axios.post(
      `${domain.domainNameForApi}ReporteGeneral/conclusionImpulsos`,
      formData
    );
    return response.data;
  },
  async ObtenerCalificacion(vm, nrreporte, svindice) {
    var formData = new FormData();
    formData.append("nrreporte", nrreporte);
    formData.append("svindice", svindice);
    let response = await vm.axios.post(`${domain.domainNameForApi}ReporteGeneral/ObtenerCalificacion`, formData);
    return response.data[0];
  }
};
